module.exports = __webpack_public_path__ + "img/happy-young-man.ccaccd2c.png";